import React from "react"
import themes from "assets/data/themes.json"
import HomeLayout from 'layouts/HomeLayout'
import Item from "./Item"
import useShare from "utils/wechat/useShare"
import useConfig from "utils/wechat/useConfig"
import config from "config/default"

const { documentTitle, documentDescription, cdnUrl } = config

const shareConfig = {
    imgUrl: cdnUrl + '/logo.jpg',
    title: documentTitle,
    desc: documentDescription,
}

/**
 * 首页
 */
export default function HomeRoute() {
    const { wechatReady } = useConfig()
    useShare(wechatReady, shareConfig)

    return (
        <HomeLayout>
            {
                themes.map(item => (
                    <Item key={item.name} item={item} />
                ))
            }
        </HomeLayout>
    )
}